import React from 'react';
import { StyleSheet, View } from 'react-native';
import { format, parseISO } from 'date-fns';
import { useGroupAvatarPicker } from 'features/group/hooks/useGroupAvatarPicker';
import Text from 'design-system/Text';
import { EditableAvatar } from 'design-system/EditableAvatar';
import { rem } from 'design-system';
import Button from 'design-system/Button';
import { IconUserPlus } from 'design-system/icons';
import useColors from 'hooks/useColors';
import { formatPlural } from 'utils';
const GroupHeader = ({ group, onAddMembers }) => {
    const showGroupAvatarImagePicker = useGroupAvatarPicker(group);
    const colors = useColors();
    const memberCount = group.userIds.length || 1;
    return (<View style={styles.container}>
      <View style={styles.headerContainer}>
        <View style={styles.groupName}>
          <Text Text-32 numberOfLines={2}>
            {group.name}
          </Text>
          <Text TextThin-14 Secondary>
            {memberCount} {formatPlural('Member', 'Members', memberCount)} |
            Created {format(parseISO(group.createdAt), 'MMM yyyy')}
          </Text>
        </View>
        <EditableAvatar name={group.name} imageUrl={group.iconUrl} onPress={showGroupAvatarImagePicker}/>
      </View>
      <Button brandReversed hug medium title="Add members" containerStyle={styles.inviteFriendsButton} onPress={onAddMembers} leftIcon={<IconUserPlus color={colors.text.textOnBrand}/>}/>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        marginBottom: rem(24),
    },
    groupName: {
        flex: 1,
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: rem(16),
        margin: rem(16),
        marginBottom: rem(24),
    },
    inviteFriendsButton: {
        alignSelf: 'flex-start',
        marginHorizontal: rem(16),
    },
});
export default GroupHeader;
